module.exports = __webpack_public_path__ + "img/topSon.a95b5e8f.svg";